"use strict";

/*
 * Video providers we no longer support. Neither has a path in the writer that
 * creates new embeds, so these only appear in archived story text.
 *
 * Gated on REMOVE_LEGACY_VIDEO_EMBEDS: this removes visible content from
 * existing stories on a high-traffic page, so it rolls out gradually and can be
 * switched off. When the flag reaches 100% the per-provider rendering blocks in
 * parse-embedded-media.js, parse-amp-media.js and the client handlebars helper
 * (and the inline_video partial they use) can be deleted outright.
 *
 * This module is shared by all three of those callers on purpose: SSR, AMP and
 * the client hydration pass have to agree exactly, or a part renders
 * differently before and after hydration.
 */
var UNSUPPORTED_VIDEO_SOURCES = ["vine", "wattpad"];

/*
 * Every attribute the embed markup carries -- see
 * core/templates/story-reading/inline-video.hbs, which writes all six onto the
 * paragraph. Stripping the attributes as well as the children is what makes the
 * removal stick: the markup is re-parsed by the client helper after hydration
 * and can be re-saved by the writer, so a leftover data-video-id would just be
 * carried forward.
 */
var MEDIA_ATTRIBUTES = [
  "data-media-type",
  "data-video-source",
  "data-video-id",
  "data-preview-image",
  "data-original-width",
  "data-original-height"
];

/*
 * One grouped selector rather than one scan per provider. The values are
 * quoted: an unquoted attribute selector is only legal for values that are bare
 * CSS identifiers, and cheerio and querySelectorAll disagree about what they do
 * with the rest (one matches, the other throws).
 */
var UNSUPPORTED_VIDEO_SELECTOR = UNSUPPORTED_VIDEO_SOURCES.map(function(
  source
) {
  return '[data-video-source="' + source + '"]';
}).join(",");

/*
 * Reduces each unsupported embed to an empty paragraph.
 *
 * `$root` is a cheerio root selection on the server and a jQuery wrapper around
 * the part text on the client; both expose the same find/empty/removeAttr API,
 * and both apply empty/removeAttr across the whole matched set.
 *
 * Doing this before the per-provider rendering blocks means those blocks match
 * nothing, which is why they need no flag check of their own.
 */
function removeUnsupportedVideoEmbeds($root) {
  var $embeds = $root.find(UNSUPPORTED_VIDEO_SELECTOR).empty();

  MEDIA_ATTRIBUTES.forEach(function(attribute) {
    $embeds.removeAttr(attribute);
  });
}

module.exports = removeUnsupportedVideoEmbeds;
module.exports.UNSUPPORTED_VIDEO_SOURCES = UNSUPPORTED_VIDEO_SOURCES;
module.exports.MEDIA_ATTRIBUTES = MEDIA_ATTRIBUTES;
module.exports.UNSUPPORTED_VIDEO_SELECTOR = UNSUPPORTED_VIDEO_SELECTOR;
